const ExpandMore = () => {
  return (
    <svg width="16" height="11" viewBox="0 0 16 11" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8 10.2188L0.5 2.71875L2.25 0.96875L8 6.71875L13.75 0.96875L15.5 2.71875L8 10.2188Z" fill="black" />
    </svg>
  );
};

export default ExpandMore;
